import { keys } from 'ts-transformer-keys';

type RequiredKeys<T> = { [K in keyof T]-? : {} extends Pick<T, K> ? never : K }[keyof T];
type RequiredOf<T> = Pick<T, RequiredKeys<T>>;

export type MailServer = {
    id: number;
    key: string;
    name: string;

    hostname: string;
    port: string;
    authType: 'Login' | 'OAuth2' | 'ServiceAccount' | 'Graph' | 'None';

    username?: string;
    password?: string;

    // =========================
    // OAUTH / SMTP OAUTH
    // =========================
    accessToken?: string;
    accessUrl?: string;
    scope?: string;
    clientId?: string;
    clientSecret?: string;
    refreshToken?: string;

    // =========================
    // GRAPH (NEW)
    // =========================
    tenantId?: string;

    /**
     * Optional: falls du App-only Graph nutzt,
     * wird immer bevorzugt über clientSecret + tenantId + clientId
     */
    graphClientId?: string;
    graphClientSecret?: string;

    /**
     * optional fallback user (für /users/{id}/sendMail)
     */
    graphUser?: string;

    // =========================
    // SERVICE ACCOUNT
    // =========================
    serviceClient?: string;
    privateKey?: string;

    // =========================
    // DKIM
    // =========================
    dkimEnabled?: boolean;
    dkimDomain?: string;
    dkimSelector?: string;
    dkimPrivateKey?: string;

    // =========================
    // TLS / SMTP
    // =========================
    secure?: boolean;
    ignoreTls?: boolean;
    requireTls?: boolean;
    opportunisticTls?: boolean;

    connectionTimeout: number;
    greetingTimeout: number;
    socketTimeout: number;
};

export const mailServerProps = keys<MailServer>();
export const requiredMailServerProps = keys<RequiredOf<MailServer>>();